/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var AddTeamMemberToTeamAccountErrorCode;
(function (AddTeamMemberToTeamAccountErrorCode) {
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ACTIVE_MEMBERSHIP_NOT_FOUND"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ACTIVE_MEMBERSHIP_NOT_FOUND";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ALREADY_BELONGS_TO_OTHER_TEAM"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ALREADY_BELONGS_TO_OTHER_TEAM";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ALREADY_INVITED_BY_OTHER_TEAM"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_ALREADY_INVITED_BY_OTHER_TEAM";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_INVALID_EMAIL"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_INVALID_EMAIL";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_MAX_EMAILS_LIMIT_EXCEEDED"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_MAX_EMAILS_LIMIT_EXCEEDED";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_MEMBERS_PER_TEAM_ACCOUNT_PLAN_LIMIT_EXCEEDED"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_MEMBERS_PER_TEAM_ACCOUNT_PLAN_LIMIT_EXCEEDED";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_PERMISSION_DENIED"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_PERMISSION_DENIED";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_MEMBER_NOT_FOUND_BY_CONSUMER_ID"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_MEMBER_NOT_FOUND_BY_CONSUMER_ID";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_NOT_FOUND_BY_ID"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_TEAM_NOT_FOUND_BY_ID";
    AddTeamMemberToTeamAccountErrorCode["ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_UNSPECIFIED"] = "ADD_TEAM_MEMBER_TO_TEAM_ACCOUNT_ERROR_CODE_UNSPECIFIED";
})(AddTeamMemberToTeamAccountErrorCode || (AddTeamMemberToTeamAccountErrorCode = {}));
export var AddTeamMembersToGroupByEmailErrorCode;
(function (AddTeamMembersToGroupByEmailErrorCode) {
    AddTeamMembersToGroupByEmailErrorCode["ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_ACCOUNT_MEMBERSHIP_NOT_FOUND"] = "ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_ACCOUNT_MEMBERSHIP_NOT_FOUND";
    AddTeamMembersToGroupByEmailErrorCode["ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_MEMBER_BELONGS_TO_OTHER_TEAM"] = "ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_MEMBER_BELONGS_TO_OTHER_TEAM";
    AddTeamMembersToGroupByEmailErrorCode["ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_TEAM_MEMBER_NOT_FOUND"] = "ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_TEAM_MEMBER_NOT_FOUND";
    AddTeamMembersToGroupByEmailErrorCode["ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_UNSPECIFIED"] = "ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_UNSPECIFIED";
})(AddTeamMembersToGroupByEmailErrorCode || (AddTeamMembersToGroupByEmailErrorCode = {}));
export var BudgetNotificationType;
(function (BudgetNotificationType) {
    BudgetNotificationType["BUDGET_CREATED"] = "BUDGET_CREATED";
    BudgetNotificationType["BUDGET_UPDATED"] = "BUDGET_UPDATED";
    BudgetNotificationType["MANUAL_TRIGGER"] = "MANUAL_TRIGGER";
    BudgetNotificationType["UNSPECIFIED"] = "UNSPECIFIED";
})(BudgetNotificationType || (BudgetNotificationType = {}));
export var BudgetTypeEnum;
(function (BudgetTypeEnum) {
    BudgetTypeEnum["DEFAULT_BUDGET"] = "DEFAULT_BUDGET";
    BudgetTypeEnum["VOUCHER"] = "VOUCHER";
})(BudgetTypeEnum || (BudgetTypeEnum = {}));
export var ClaimVoucherErrorCode;
(function (ClaimVoucherErrorCode) {
    ClaimVoucherErrorCode["ERROR_CODE_ACCOUNT_MEMBERSHIP_ISSUE"] = "ERROR_CODE_ACCOUNT_MEMBERSHIP_ISSUE";
    ClaimVoucherErrorCode["ERROR_CODE_ALREADY_IN_ANOTHER_TEAM"] = "ERROR_CODE_ALREADY_IN_ANOTHER_TEAM";
    ClaimVoucherErrorCode["ERROR_CODE_ALREADY_IN_YOUR_ACCOUNT"] = "ERROR_CODE_ALREADY_IN_YOUR_ACCOUNT";
    ClaimVoucherErrorCode["ERROR_CODE_ALREADY_REDEEMED"] = "ERROR_CODE_ALREADY_REDEEMED";
    ClaimVoucherErrorCode["ERROR_CODE_EXPIRED_VOUCHER"] = "ERROR_CODE_EXPIRED_VOUCHER";
    ClaimVoucherErrorCode["ERROR_CODE_INACTIVE_TEAM_ACCOUNT"] = "ERROR_CODE_INACTIVE_TEAM_ACCOUNT";
    ClaimVoucherErrorCode["ERROR_CODE_INVALID_VOUCHER"] = "ERROR_CODE_INVALID_VOUCHER";
    ClaimVoucherErrorCode["ERROR_CODE_MAX_REDEEMED_NUMBER_REACHED"] = "ERROR_CODE_MAX_REDEEMED_NUMBER_REACHED";
    ClaimVoucherErrorCode["ERROR_CODE_UNSPECIFIED"] = "ERROR_CODE_UNSPECIFIED";
})(ClaimVoucherErrorCode || (ClaimVoucherErrorCode = {}));
export var CreateDdfwTeamAndTeamAccountStatus;
(function (CreateDdfwTeamAndTeamAccountStatus) {
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_ERROR"] = "ONBOARD_TEAM_ACCOUNT_STATUS_ERROR";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_IN_PROGRESS"] = "ONBOARD_TEAM_ACCOUNT_STATUS_IN_PROGRESS";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_SUCCESS"] = "ONBOARD_TEAM_ACCOUNT_STATUS_SUCCESS";
    CreateDdfwTeamAndTeamAccountStatus["ONBOARD_TEAM_ACCOUNT_STATUS_UNSPECIFIED"] = "ONBOARD_TEAM_ACCOUNT_STATUS_UNSPECIFIED";
})(CreateDdfwTeamAndTeamAccountStatus || (CreateDdfwTeamAndTeamAccountStatus = {}));
export var CreateTeamAccountOfficeErrorCode;
(function (CreateTeamAccountOfficeErrorCode) {
    CreateTeamAccountOfficeErrorCode["ERROR_CODE_OFFICE_ALREADY_EXISTS"] = "ERROR_CODE_OFFICE_ALREADY_EXISTS";
    CreateTeamAccountOfficeErrorCode["ERROR_CODE_PERMISSION_DENIED"] = "ERROR_CODE_PERMISSION_DENIED";
    CreateTeamAccountOfficeErrorCode["ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND"] = "ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND";
    CreateTeamAccountOfficeErrorCode["ERROR_CODE_UNSPECIFIED"] = "ERROR_CODE_UNSPECIFIED";
})(CreateTeamAccountOfficeErrorCode || (CreateTeamAccountOfficeErrorCode = {}));
export var DeleteTeamAccountOfficeErrorCode;
(function (DeleteTeamAccountOfficeErrorCode) {
    DeleteTeamAccountOfficeErrorCode["ERROR_CODE_OFFICE_NOT_FOUND"] = "ERROR_CODE_OFFICE_NOT_FOUND";
    DeleteTeamAccountOfficeErrorCode["ERROR_CODE_PERMISSION_DENIED"] = "ERROR_CODE_PERMISSION_DENIED";
    DeleteTeamAccountOfficeErrorCode["ERROR_CODE_UNSPECIFIED"] = "ERROR_CODE_UNSPECIFIED";
})(DeleteTeamAccountOfficeErrorCode || (DeleteTeamAccountOfficeErrorCode = {}));
export var DropoffType;
(function (DropoffType) {
    DropoffType["DROPOFF_HAND_IT_TO_ME"] = "DROPOFF_HAND_IT_TO_ME";
    DropoffType["DROPOFF_LEAVE_AT_DOOR"] = "DROPOFF_LEAVE_AT_DOOR";
    DropoffType["UNSPECIFIED"] = "UNSPECIFIED";
})(DropoffType || (DropoffType = {}));
/**
 * Border Shape Enum
 */
export var FacetV2BorderShapeStyle;
(function (FacetV2BorderShapeStyle) {
    FacetV2BorderShapeStyle["BORDER_STYLE_DASHED"] = "BORDER_STYLE_DASHED";
    FacetV2BorderShapeStyle["BORDER_STYLE_UNSPECIFIED"] = "BORDER_STYLE_UNSPECIFIED";
})(FacetV2BorderShapeStyle || (FacetV2BorderShapeStyle = {}));
/**
 * Color Enum
 */
export var FacetV2ColorStyle;
(function (FacetV2ColorStyle) {
    FacetV2ColorStyle["COLOR_BACKGROUND_BORDER_HIGHLIGHT"] = "COLOR_BACKGROUND_BORDER_HIGHLIGHT";
    FacetV2ColorStyle["COLOR_BACKGROUND_HIGHLIGHT"] = "COLOR_BACKGROUND_HIGHLIGHT";
    FacetV2ColorStyle["COLOR_BACKGROUND_LIGHT_RED"] = "COLOR_BACKGROUND_LIGHT_RED";
    FacetV2ColorStyle["COLOR_BACKGROUND_PRIMARY"] = "COLOR_BACKGROUND_PRIMARY";
    FacetV2ColorStyle["COLOR_BACKGROUND_SECONDARY"] = "COLOR_BACKGROUND_SECONDARY";
    FacetV2ColorStyle["COLOR_BACKGROUND_TEAL_GRADIENT"] = "COLOR_BACKGROUND_TEAL_GRADIENT";
    FacetV2ColorStyle["COLOR_BACKGROUND_TERTIARY"] = "COLOR_BACKGROUND_TERTIARY";
    FacetV2ColorStyle["COLOR_BACKGROUND_TRANSPARENT"] = "COLOR_BACKGROUND_TRANSPARENT";
    FacetV2ColorStyle["COLOR_BACKGROUND_WHITE"] = "COLOR_BACKGROUND_WHITE";
    FacetV2ColorStyle["COLOR_BANNER_HIGHLIGHT_DEFAULT_BACKGROUND"] = "COLOR_BANNER_HIGHLIGHT_DEFAULT_BACKGROUND";
    FacetV2ColorStyle["COLOR_LIST_CELL_CONTAINER_BACKGROUND_UNREAD"] = "COLOR_LIST_CELL_CONTAINER_BACKGROUND_UNREAD";
    FacetV2ColorStyle["COLOR_UNSPECIFIED"] = "COLOR_UNSPECIFIED";
})(FacetV2ColorStyle || (FacetV2ColorStyle = {}));
export var FacetV2ImageStyle;
(function (FacetV2ImageStyle) {
    FacetV2ImageStyle["CIRCLE"] = "CIRCLE";
    FacetV2ImageStyle["ROUNDED"] = "ROUNDED";
    FacetV2ImageStyle["UNSPECIFIED"] = "UNSPECIFIED";
})(FacetV2ImageStyle || (FacetV2ImageStyle = {}));
/**
 * Spacing Enum
 */
export var FacetV2SpacingStyle;
(function (FacetV2SpacingStyle) {
    FacetV2SpacingStyle["SPACING_LARGE"] = "SPACING_LARGE";
    FacetV2SpacingStyle["SPACING_MEDIUM"] = "SPACING_MEDIUM";
    FacetV2SpacingStyle["SPACING_NONE"] = "SPACING_NONE";
    FacetV2SpacingStyle["SPACING_SMALL"] = "SPACING_SMALL";
    FacetV2SpacingStyle["SPACING_UNSPECIFIED"] = "SPACING_UNSPECIFIED";
    FacetV2SpacingStyle["SPACING_XXXX_LARGE"] = "SPACING_XXXX_LARGE";
    FacetV2SpacingStyle["SPACING_XXXX_SMALL"] = "SPACING_XXXX_SMALL";
    FacetV2SpacingStyle["SPACING_XXX_LARGE"] = "SPACING_XXX_LARGE";
    FacetV2SpacingStyle["SPACING_XXX_SMALL"] = "SPACING_XXX_SMALL";
    FacetV2SpacingStyle["SPACING_XX_LARGE"] = "SPACING_XX_LARGE";
    FacetV2SpacingStyle["SPACING_XX_SMALL"] = "SPACING_XX_SMALL";
    FacetV2SpacingStyle["SPACING_X_LARGE"] = "SPACING_X_LARGE";
    FacetV2SpacingStyle["SPACING_X_SMALL"] = "SPACING_X_SMALL";
})(FacetV2SpacingStyle || (FacetV2SpacingStyle = {}));
/**
 * Text Color Enum
 */
export var FacetV2TextColor;
(function (FacetV2TextColor) {
    FacetV2TextColor["DLS_TEXT_COLOR_ACCENTED_PRIMARY"] = "DLS_TEXT_COLOR_ACCENTED_PRIMARY";
    FacetV2TextColor["DLS_TEXT_COLOR_ACCENTED_SECONDARY"] = "DLS_TEXT_COLOR_ACCENTED_SECONDARY";
    FacetV2TextColor["DLS_TEXT_COLOR_ERROR"] = "DLS_TEXT_COLOR_ERROR";
    FacetV2TextColor["DLS_TEXT_COLOR_POSITIVE"] = "DLS_TEXT_COLOR_POSITIVE";
    FacetV2TextColor["DLS_TEXT_COLOR_PRIMARY"] = "DLS_TEXT_COLOR_PRIMARY";
    FacetV2TextColor["DLS_TEXT_COLOR_SECONDARY"] = "DLS_TEXT_COLOR_SECONDARY";
    FacetV2TextColor["DLS_TEXT_COLOR_TEXT_TERTIARY"] = "DLS_TEXT_COLOR_TEXT_TERTIARY";
    FacetV2TextColor["DLS_TEXT_COLOR_UNSPECIFIED"] = "DLS_TEXT_COLOR_UNSPECIFIED";
    FacetV2TextColor["DLS_TEXT_COLOR_WARNING"] = "DLS_TEXT_COLOR_WARNING";
})(FacetV2TextColor || (FacetV2TextColor = {}));
/**
 * Text Style Enum
 */
export var FacetV2TextStyle;
(function (FacetV2TextStyle) {
    FacetV2TextStyle["DLS_TEXT_STYLE_BODY_1"] = "DLS_TEXT_STYLE_BODY_1";
    FacetV2TextStyle["DLS_TEXT_STYLE_BODY_2"] = "DLS_TEXT_STYLE_BODY_2";
    FacetV2TextStyle["DLS_TEXT_STYLE_BODY_2_EMPHASIS"] = "DLS_TEXT_STYLE_BODY_2_EMPHASIS";
    FacetV2TextStyle["DLS_TEXT_STYLE_CAPTION_2"] = "DLS_TEXT_STYLE_CAPTION_2";
    FacetV2TextStyle["DLS_TEXT_STYLE_LABEL_1_EMPHASIS"] = "DLS_TEXT_STYLE_LABEL_1_EMPHASIS";
    FacetV2TextStyle["DLS_TEXT_STYLE_LABEL_2"] = "DLS_TEXT_STYLE_LABEL_2";
    FacetV2TextStyle["DLS_TEXT_STYLE_LABEL_2_EMPHASIS"] = "DLS_TEXT_STYLE_LABEL_2_EMPHASIS";
    FacetV2TextStyle["DLS_TEXT_STYLE_LIST_ROW_TITLE_LARGE"] = "DLS_TEXT_STYLE_LIST_ROW_TITLE_LARGE";
    FacetV2TextStyle["DLS_TEXT_STYLE_MAJOR_PAGE_TITLE"] = "DLS_TEXT_STYLE_MAJOR_PAGE_TITLE";
    FacetV2TextStyle["DLS_TEXT_STYLE_MAP_UI_TEXT_ON_MAP_UNSELECTED"] = "DLS_TEXT_STYLE_MAP_UI_TEXT_ON_MAP_UNSELECTED";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_SECTION_SUBTEXT"] = "DLS_TEXT_STYLE_PAGE_SECTION_SUBTEXT";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_SECTION_TITLE"] = "DLS_TEXT_STYLE_PAGE_SECTION_TITLE";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_SECTION_TITLE_LARGE"] = "DLS_TEXT_STYLE_PAGE_SECTION_TITLE_LARGE";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_TITLE"] = "DLS_TEXT_STYLE_PAGE_TITLE";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_TITLE_1"] = "DLS_TEXT_STYLE_PAGE_TITLE_1";
    FacetV2TextStyle["DLS_TEXT_STYLE_PAGE_TITLE_2"] = "DLS_TEXT_STYLE_PAGE_TITLE_2";
    FacetV2TextStyle["DLS_TEXT_STYLE_TITLE_1"] = "DLS_TEXT_STYLE_TITLE_1";
    FacetV2TextStyle["DLS_TEXT_STYLE_TITLE_2"] = "DLS_TEXT_STYLE_TITLE_2";
    FacetV2TextStyle["DLS_TEXT_STYLE_UNSPECIFIED"] = "DLS_TEXT_STYLE_UNSPECIFIED";
})(FacetV2TextStyle || (FacetV2TextStyle = {}));
/**
 * Width Enum
 */
export var FacetV2WidthStyle;
(function (FacetV2WidthStyle) {
    FacetV2WidthStyle["BORDER_WIDTH_BOLD"] = "BORDER_WIDTH_BOLD";
    FacetV2WidthStyle["BORDER_WIDTH_DEFAULT"] = "BORDER_WIDTH_DEFAULT";
    FacetV2WidthStyle["BORDER_WIDTH_HAIRLINE"] = "BORDER_WIDTH_HAIRLINE";
    FacetV2WidthStyle["BORDER_WIDTH_MEDIUM"] = "BORDER_WIDTH_MEDIUM";
    FacetV2WidthStyle["BORDER_WIDTH_NONE"] = "BORDER_WIDTH_NONE";
    FacetV2WidthStyle["BORDER_WIDTH_REGULAR"] = "BORDER_WIDTH_REGULAR";
    FacetV2WidthStyle["BORDER_WIDTH_UNSPECIFIED"] = "BORDER_WIDTH_UNSPECIFIED";
})(FacetV2WidthStyle || (FacetV2WidthStyle = {}));
export var GroupOrderEntryErrorCode;
(function (GroupOrderEntryErrorCode) {
    GroupOrderEntryErrorCode["ERROR_CODE_CARTS_CREATION_FAILED"] = "ERROR_CODE_CARTS_CREATION_FAILED";
    GroupOrderEntryErrorCode["ERROR_CODE_DELETE_NOT_SUPPORTED"] = "ERROR_CODE_DELETE_NOT_SUPPORTED";
    GroupOrderEntryErrorCode["ERROR_CODE_ENTRY_NOT_EXISTED"] = "ERROR_CODE_ENTRY_NOT_EXISTED";
    GroupOrderEntryErrorCode["ERROR_CODE_INVALID_MENU"] = "ERROR_CODE_INVALID_MENU";
    GroupOrderEntryErrorCode["ERROR_CODE_INVALID_STORE"] = "ERROR_CODE_INVALID_STORE";
    GroupOrderEntryErrorCode["ERROR_CODE_PERMISSION_DENIED"] = "ERROR_CODE_PERMISSION_DENIED";
    GroupOrderEntryErrorCode["ERROR_CODE_STORE_CLOSED"] = "ERROR_CODE_STORE_CLOSED";
    GroupOrderEntryErrorCode["ERROR_CODE_UNKNOWN"] = "ERROR_CODE_UNKNOWN";
    GroupOrderEntryErrorCode["ERROR_CODE_UNSPECIFIED"] = "ERROR_CODE_UNSPECIFIED";
    GroupOrderEntryErrorCode["ERROR_CODE_UPDATE_NOT_SUPPORTED"] = "ERROR_CODE_UPDATE_NOT_SUPPORTED";
})(GroupOrderEntryErrorCode || (GroupOrderEntryErrorCode = {}));
export var GroupOrderEntryStatus;
(function (GroupOrderEntryStatus) {
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_FAILURE"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_FAILURE";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_SUCCESS"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_SUCCESS";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_PUBLISHED"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_PUBLISHED";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_SUBMITTED_FAILURE"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_SUBMITTED_FAILURE";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_SUBMITTED_SUCCESS"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_SUBMITTED_SUCCESS";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_ENTRY_CREATED"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_ENTRY_CREATED";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_CANCELLED"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_CANCELLED";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_DELIVERY_COMPLETED"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_DELIVERY_COMPLETED";
    GroupOrderEntryStatus["RECURRING_GROUP_ORDER_CALENDAR_STATUS_UNSPECIFIED"] = "RECURRING_GROUP_ORDER_CALENDAR_STATUS_UNSPECIFIED";
})(GroupOrderEntryStatus || (GroupOrderEntryStatus = {}));
export var JoinTeamAccountsV2ErrorCode;
(function (JoinTeamAccountsV2ErrorCode) {
    JoinTeamAccountsV2ErrorCode["ALREADY_ACTIVE"] = "ALREADY_ACTIVE";
    JoinTeamAccountsV2ErrorCode["DIFFERENT_TEAM"] = "DIFFERENT_TEAM";
    JoinTeamAccountsV2ErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    JoinTeamAccountsV2ErrorCode["INVALID_PENDING_MEMBER_ID"] = "INVALID_PENDING_MEMBER_ID";
    JoinTeamAccountsV2ErrorCode["PERSONAL_LOGIN_IS_DISABLED"] = "PERSONAL_LOGIN_IS_DISABLED";
    JoinTeamAccountsV2ErrorCode["UNSPECIFIED"] = "UNSPECIFIED";
    JoinTeamAccountsV2ErrorCode["WRONG_PENDING_MEMBER_ID"] = "WRONG_PENDING_MEMBER_ID";
})(JoinTeamAccountsV2ErrorCode || (JoinTeamAccountsV2ErrorCode = {}));
export var LimitationType;
(function (LimitationType) {
    LimitationType["MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY"] = "MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY";
    LimitationType["MAX_BUDGETS_PER_TEAM_ACCOUNT"] = "MAX_BUDGETS_PER_TEAM_ACCOUNT";
    LimitationType["MAX_BUDGET_AMOUNT"] = "MAX_BUDGET_AMOUNT";
    LimitationType["MAX_MEMBERS_PER_TEAM_ACCOUNT"] = "MAX_MEMBERS_PER_TEAM_ACCOUNT";
    LimitationType["UNKNOWN_LIMITATION_TYPE"] = "UNKNOWN_LIMITATION_TYPE";
})(LimitationType || (LimitationType = {}));
export var ListTeamAccountOfficesErrorCode;
(function (ListTeamAccountOfficesErrorCode) {
    ListTeamAccountOfficesErrorCode["ERROR_CODE_PERMISSION_DENIED"] = "ERROR_CODE_PERMISSION_DENIED";
    ListTeamAccountOfficesErrorCode["ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND"] = "ERROR_CODE_TEAM_ACCOUNT_NOT_FOUND";
    ListTeamAccountOfficesErrorCode["ERROR_CODE_UNSPECIFIED"] = "ERROR_CODE_UNSPECIFIED";
})(ListTeamAccountOfficesErrorCode || (ListTeamAccountOfficesErrorCode = {}));
/**
 * new team account onboarding steps
 */
export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["ONBOARDING_STEP_ACTIVATE_DASHPASS"] = "ONBOARDING_STEP_ACTIVATE_DASHPASS";
    OnboardingStep["ONBOARDING_STEP_ADD_BUDGET"] = "ONBOARDING_STEP_ADD_BUDGET";
    OnboardingStep["ONBOARDING_STEP_ADD_MEMBER"] = "ONBOARDING_STEP_ADD_MEMBER";
    OnboardingStep["ONBOARDING_STEP_ADD_PAYMENT_METHOD"] = "ONBOARDING_STEP_ADD_PAYMENT_METHOD";
    OnboardingStep["ONBOARDING_STEP_FINISH_ONBOARDING"] = "ONBOARDING_STEP_FINISH_ONBOARDING";
    OnboardingStep["ONBOARDING_STEP_UNKNOWN"] = "ONBOARDING_STEP_UNKNOWN";
})(OnboardingStep || (OnboardingStep = {}));
export var PaymentMethodConfigCountry;
(function (PaymentMethodConfigCountry) {
    PaymentMethodConfigCountry["AU"] = "AU";
    PaymentMethodConfigCountry["CA"] = "CA";
    PaymentMethodConfigCountry["DE"] = "DE";
    PaymentMethodConfigCountry["JP"] = "JP";
    PaymentMethodConfigCountry["MX"] = "MX";
    PaymentMethodConfigCountry["NZ"] = "NZ";
    PaymentMethodConfigCountry["PR"] = "PR";
    PaymentMethodConfigCountry["US"] = "US";
})(PaymentMethodConfigCountry || (PaymentMethodConfigCountry = {}));
export var PaymentMethodConfigProvider;
(function (PaymentMethodConfigProvider) {
    PaymentMethodConfigProvider["braintree"] = "braintree";
    PaymentMethodConfigProvider["jpm"] = "jpm";
    PaymentMethodConfigProvider["stripe"] = "stripe";
    PaymentMethodConfigProvider["vgs"] = "vgs";
    PaymentMethodConfigProvider["vgs_payment"] = "vgs_payment";
})(PaymentMethodConfigProvider || (PaymentMethodConfigProvider = {}));
export var PreviewVoucherRedemptionErrorCode;
(function (PreviewVoucherRedemptionErrorCode) {
    PreviewVoucherRedemptionErrorCode["ALREADY_ACCEPTED_VOUCHER"] = "ALREADY_ACCEPTED_VOUCHER";
    PreviewVoucherRedemptionErrorCode["INVALID_VOUCHER"] = "INVALID_VOUCHER";
    PreviewVoucherRedemptionErrorCode["UNSPECIFIED"] = "UNSPECIFIED";
})(PreviewVoucherRedemptionErrorCode || (PreviewVoucherRedemptionErrorCode = {}));
export var ScheduleOptionType;
(function (ScheduleOptionType) {
    ScheduleOptionType["IMMEDIATE"] = "IMMEDIATE";
    ScheduleOptionType["SCHEDULED"] = "SCHEDULED";
    ScheduleOptionType["UNSPECIFIED"] = "UNSPECIFIED";
})(ScheduleOptionType || (ScheduleOptionType = {}));
export var SendBudgetReminderErrorCode;
(function (SendBudgetReminderErrorCode) {
    SendBudgetReminderErrorCode["ACTIVE_BUDGET_NOT_FOUND"] = "ACTIVE_BUDGET_NOT_FOUND";
    SendBudgetReminderErrorCode["BUDGET_EXPIRED"] = "BUDGET_EXPIRED";
    SendBudgetReminderErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    SendBudgetReminderErrorCode["TEAM_MEMBER_INCONSISTENT_STATE"] = "TEAM_MEMBER_INCONSISTENT_STATE";
    SendBudgetReminderErrorCode["UNSPECIFIED"] = "UNSPECIFIED";
})(SendBudgetReminderErrorCode || (SendBudgetReminderErrorCode = {}));
export var SendJoinInvitationEmailErrorCode;
(function (SendJoinInvitationEmailErrorCode) {
    SendJoinInvitationEmailErrorCode["EMAIL_NOT_FOUND"] = "EMAIL_NOT_FOUND";
    SendJoinInvitationEmailErrorCode["INVALID_EMAIL"] = "INVALID_EMAIL";
    SendJoinInvitationEmailErrorCode["TEAM_ACCOUNT_NOT_FOUND"] = "TEAM_ACCOUNT_NOT_FOUND";
    SendJoinInvitationEmailErrorCode["TEAM_NOT_FOUND"] = "TEAM_NOT_FOUND";
    SendJoinInvitationEmailErrorCode["UNSPECIFIED"] = "UNSPECIFIED";
})(SendJoinInvitationEmailErrorCode || (SendJoinInvitationEmailErrorCode = {}));
export var TeamAccountPlan;
(function (TeamAccountPlan) {
    TeamAccountPlan["WORK_PLAN_MANUAL_MANAGEMENT_FREE"] = "WORK_PLAN_MANUAL_MANAGEMENT_FREE";
    TeamAccountPlan["WORK_PLAN_SELF_SERVE_FREE"] = "WORK_PLAN_SELF_SERVE_FREE";
})(TeamAccountPlan || (TeamAccountPlan = {}));
/**
 * Team member role types
 */
export var TeamMemberRole;
(function (TeamMemberRole) {
    TeamMemberRole["ADMIN"] = "ADMIN";
    TeamMemberRole["MEMBER"] = "MEMBER";
})(TeamMemberRole || (TeamMemberRole = {}));
/**
 * types of team member status
 */
export var TeamMemberStatus;
(function (TeamMemberStatus) {
    TeamMemberStatus["ACTIVE"] = "ACTIVE";
    TeamMemberStatus["PENDING"] = "PENDING";
})(TeamMemberStatus || (TeamMemberStatus = {}));
export var UpdateTeamAccountOfficeErrorCode;
(function (UpdateTeamAccountOfficeErrorCode) {
    UpdateTeamAccountOfficeErrorCode["OFFICE_ALREADY_EXISTS"] = "OFFICE_ALREADY_EXISTS";
    UpdateTeamAccountOfficeErrorCode["OFFICE_NOT_FOUND"] = "OFFICE_NOT_FOUND";
    UpdateTeamAccountOfficeErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    UpdateTeamAccountOfficeErrorCode["UNSPECIFIED"] = "UNSPECIFIED";
})(UpdateTeamAccountOfficeErrorCode || (UpdateTeamAccountOfficeErrorCode = {}));
export var VoucherStatusEnum;
(function (VoucherStatusEnum) {
    VoucherStatusEnum["STATUS_EXPIRED"] = "STATUS_EXPIRED";
    VoucherStatusEnum["STATUS_LIVE"] = "STATUS_LIVE";
    VoucherStatusEnum["STATUS_SCHEDULED"] = "STATUS_SCHEDULED";
    VoucherStatusEnum["STATUS_UNSPECIFIED"] = "STATUS_UNSPECIFIED";
})(VoucherStatusEnum || (VoucherStatusEnum = {}));
export var VoucherTypeEnum;
(function (VoucherTypeEnum) {
    VoucherTypeEnum["GENERIC"] = "GENERIC";
    VoucherTypeEnum["UNIQUE"] = "UNIQUE";
    VoucherTypeEnum["UNSPECIFIED"] = "UNSPECIFIED";
})(VoucherTypeEnum || (VoucherTypeEnum = {}));
/**
 * types of work benefit offered on team account
 */
export var WorkBenefit;
(function (WorkBenefit) {
    WorkBenefit["WORK_BENEFIT_DASHPASS"] = "WORK_BENEFIT_DASHPASS";
    WorkBenefit["WORK_BENEFIT_EXPENSED_MEALS"] = "WORK_BENEFIT_EXPENSED_MEALS";
    WorkBenefit["WORK_BENEFIT_UNSPECIFIED"] = "WORK_BENEFIT_UNSPECIFIED";
})(WorkBenefit || (WorkBenefit = {}));
/**
 * workflow name is used for retrieving the selected workflow status
 */
export var WorkflowName;
(function (WorkflowName) {
    WorkflowName["WORKFLOW_NAME_ACTIVATE_BENEFIT"] = "WORKFLOW_NAME_ACTIVATE_BENEFIT";
    WorkflowName["WORKFLOW_NAME_ONBOARD_TEAM_ACCOUNT"] = "WORKFLOW_NAME_ONBOARD_TEAM_ACCOUNT";
    WorkflowName["WORKFLOW_NAME_REMOVE_BENEFIT"] = "WORKFLOW_NAME_REMOVE_BENEFIT";
})(WorkflowName || (WorkflowName = {}));
export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["WORKFLOW_STATUS_ERROR"] = "WORKFLOW_STATUS_ERROR";
    WorkflowStatus["WORKFLOW_STATUS_IN_PROGRESS"] = "WORKFLOW_STATUS_IN_PROGRESS";
    WorkflowStatus["WORKFLOW_STATUS_SUCCESS"] = "WORKFLOW_STATUS_SUCCESS";
    WorkflowStatus["WORKFLOW_STATUS_UNSPECIFIED"] = "WORKFLOW_STATUS_UNSPECIFIED";
})(WorkflowStatus || (WorkflowStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
